<template>
	<div class="dashboard-components">
		<div class="dashboard-p1-left">
			<div class="dashboard-container">
				<div class="dashboard-title">
					<h2>净{{indextype}}{{queryindex}}
					<el-select v-model="type" placeholder="请选择" size="mini" @change="initMiniBar(type)" popper-class="singlecodetopselect">
						<el-option
							class="barchart-miniselector"
							v-for="item in typeoptions"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>						
					</h2>
				</div>
				<div class="dashboard-p1-bar1">
					<div id="dashboardbarid01" class="dashboard-p1-bar1-item"></div>
				</div>
			</div>
			<div class="dashboard-container" style="margin-top:10px;">
				<div class="dashboard-title">
					<h2>进口 vs. 出口</h2>
				</div>
				<div class="dashboard-p1-bar1">
					<div id="dashboardbarid02" class="dashboard-p1-bar1-item"></div>
				</div>
			</div>
		</div>
		<div class="dashboard-p1-center">
			<div class="dashboard-container">
				<div class="dashboard-title">
					<h2 class="color-green">进口{{queryindex}} - {{queryunit}}</h2>
				</div>
				<div class="dashboard-p1-grid">
					<div class="dashboard-p1-grid-item">
						<div class="dashboard-p1-grid-item-inner">
							<h3>{{moment(searchperiod).format('YYYY-MM')}}</h3>
							<h4><span class="fl">{{millonFormat(toFixedNumber0(chartdata.import.current.value))}}</span><span class="fr">{{chartdata.import.current.unit}}</span></h4>
							<h5><span class="fl">同比增长</span><span class="fr">{{chartdata.import.current.growth_yoy}}%</span></h5>
						</div>
					</div>
					<div class="dashboard-p1-grid-item">
						<div class="dashboard-p1-grid-item-inner">
							<h3>最近三个月 ({{moment(searchperiod).subtract(2, 'months').format('YYYY-MM')}} – {{moment(searchperiod).format('YYYY-MM')}})</h3>
							<h4><span class="fl">{{millonFormat(toFixedNumber0(chartdata.import.lastThreeMonth.value))}}</span><span class="fr">{{chartdata.import.lastThreeMonth.unit}}</span></h4>
							<h5><span class="fl">同比增长</span><span class="fr">{{chartdata.import.lastThreeMonth.growth_yoy}}%</span></h5>
						</div>
					</div>
					<div class="dashboard-p1-grid-item">
						<div class="dashboard-p1-grid-item-inner">
							<h3>当年累计 (截止{{moment(searchperiod).format('YYYY-MM')}})</h3>
							<h4><span class="fl">{{millonFormat(toFixedNumber0(chartdata.import.YTD.value))}}</span><span class="fr">{{chartdata.import.YTD.unit}}</span></h4>
							<h5><span class="fl">同比增长</span><span class="fr">{{chartdata.import.YTD.growth_yoy}}%</span></h5>
						</div>
					</div>
					<div class="dashboard-p1-grid-item">
						<div class="dashboard-p1-grid-item-inner">
							<h3>滚动年累计 ({{moment(searchperiod).subtract(11, 'months').format('YYYY-MM')}} – {{moment(searchperiod).format('YYYY-MM')}})</h3>
							<h4><span class="fl">{{millonFormat(toFixedNumber0(chartdata.import.MAT.value))}}</span><span class="fr">{{chartdata.import.MAT.unit}}</span></h4>
							<h5><span class="fl">同比增长</span><span class="fr">{{chartdata.import.MAT.growth_yoy}}%</span></h5>
						</div>
					</div>
				</div>
				<div class="dashboard-p1-bar2">
					<div id="dashboardbarid1" class="dashboard-p1-bar-item"></div>
				</div>
			</div>
		</div>
		<div class="dashboard-p1-right">
			<div class="dashboard-container">
				<div class="dashboard-title">
					<h2 class="color-red">出口{{queryindex}} - {{queryunit}}</h2>
				</div>
				<div class="dashboard-p1-grid">
					<div class="dashboard-p1-grid-item">
						<div class="dashboard-p1-grid-item-inner">
							<h3>{{moment(searchperiod).format('YYYY-MM')}}</h3>
							<h4><span class="fl">{{millonFormat(toFixedNumber0(chartdata.export.current.value))}}</span><span class="fr">{{chartdata.export.current.unit}}</span></h4>
							<h5><span class="fl">同比增长</span><span class="fr">{{chartdata.export.current.growth_yoy}}%</span></h5>
						</div>
					</div>
					<div class="dashboard-p1-grid-item">
						<div class="dashboard-p1-grid-item-inner">
							<h3>最近三个月 ({{moment(searchperiod).subtract(2, 'months').format('YYYY-MM')}} – {{moment(searchperiod).format('YYYY-MM')}})</h3>
							<h4><span class="fl">{{millonFormat(toFixedNumber0(chartdata.export.lastThreeMonth.value))}}</span><span class="fr">{{chartdata.export.lastThreeMonth.unit}}</span></h4>
							<h5><span class="fl">同比增长</span><span class="fr">{{chartdata.export.lastThreeMonth.growth_yoy}}%</span></h5>
						</div>
					</div>
					<div class="dashboard-p1-grid-item">
						<div class="dashboard-p1-grid-item-inner">
							<h3>当年累计 (截止{{moment(searchperiod).format('YYYY-MM')}})</h3>
							<h4><span class="fl">{{millonFormat(toFixedNumber0(chartdata.export.YTD.value))}}</span><span class="fr">{{chartdata.export.YTD.unit}}</span></h4>
							<h5><span class="fl">同比增长</span><span class="fr">{{chartdata.export.YTD.growth_yoy}}%</span></h5>
						</div>
					</div>
					<div class="dashboard-p1-grid-item">
						<div class="dashboard-p1-grid-item-inner">
							<h3>滚动年累计 ({{moment(searchperiod).subtract(11, 'months').format('YYYY-MM')}} – {{moment(searchperiod).format('YYYY-MM')}})</h3>
							<h4><span class="fl">{{millonFormat(toFixedNumber0(chartdata.export.MAT.value))}}</span><span class="fr">{{chartdata.export.MAT.unit}}</span></h4>
							<h5><span class="fl">同比增长</span><span class="fr">{{chartdata.export.MAT.growth_yoy}}%</span></h5>
						</div>
					</div>
				</div>
				<div class="dashboard-p1-bar2">
					<div id="dashboardbarid2" class="dashboard-p1-bar-item"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		searchperiod: String,
		chartdata: {
      type: Object
    },
		querydata: {
      type: Object
    },
	},

	data(){
		return{
			indextype: '',
			queryindex: '',
			queryunit: '',
			maincolor: '',
			type: 0,
			typeoptions: [{
				label: this.$t('SingleCodeAnalysis.t08'),
				value: 0
			},{
				label: this.$t('SingleCodeAnalysis.t07'),
				value: 1
			},{
				label: this.$t('SingleCodeAnalysis.t06'),
				value: 2
			},{
				label: '当月',
				value: 3
			}],
			currentmonth: {},
			last3month: {},
			ytdmonth: {},
			matmonth: {},
			currentmonth1: {},
			last3month1: {},
			ytdmonth1: {},
			matmonth1: {},
		}
	},

  created() {
    this.$nextTick(() => {
			this.initData(this.chartdata)
    })
  },

  watch: {
    'chartdata'() {
      this.$nextTick(() => {
				this.initData(this.chartdata)
      })
    },
  },

	methods: {

		/**
		 * 初始化数据
		 */
		initData: function(data){
			let _q = this.querydata
			if(_q.index == 'volume'){
				this.queryindex = this.$t('charttxt.t4')
			}
			if(_q.index == 'value'){
				this.queryindex = this.$t('charttxt.t3')
			}
			if(_q.index == 'volume' && _q.unit == 'first_unit'){
				this.queryunit = this.$t('charttxt.t7')
			}
			if(_q.index == 'volume' && _q.unit == 'second_unit'){
				this.queryunit = this.$t('charttxt.t8')
			}
			if(_q.index == 'value' && _q.currency == 'rmb'){
				this.queryunit = this.$t('charttxt.t6')
			}
			if(_q.index == 'value' && _q.currency == 'usd'){
				this.queryunit = this.$t('charttxt.t5')
			}

			let bar1x = []
			let bar1y = []
			for(let i=0; i<data.import.MATList.length; i++){
				bar1x.push(data.import.MATList[i].item)
				bar1y.push(data.import.MATList[i].value)
			}
			let bar1data = {
				x: bar1x,
				y: bar1y
			}
			let bar2x = []
			let bar2y = []
			for(let i=0; i<data.export.MATList.length; i++){
				bar2x.push(data.export.MATList[i].item)
				bar2y.push(data.export.MATList[i].value)
			}
			let bar2data = {
				x: bar2x,
				y: bar2y
			}

			/**
			 * 进口 VS 出口
			 * MAT: 滚动年
			 * YTD：当年累计
			 */
			if((data.export.current.value - data.import.current.value) > 0){
				this.indextype = this.$t('charttxt.t2') //出口
				this.maincolor = '#dd4124'
			}
			if((data.export.current.value - data.import.current.value) < 0){
				this.indextype = this.$t('charttxt.t1') //进口
				this.maincolor = '#009473'
			}
			let currentmonth = {
				x: ['去年', '今年'],
				y: [Math.abs(data.export.current.value_yoy - data.import.current.value_yoy),
					Math.abs(data.export.current.value - data.import.current.value)]
			}
			let last3month = {
				x: ['去年', '今年'],
				y: [Math.abs(data.export.lastThreeMonth.value_yoy - data.import.lastThreeMonth.value_yoy),
					Math.abs(data.export.lastThreeMonth.value - data.import.lastThreeMonth.value)]
			}
			let ytdmonth = {
				x: ['去年', '今年'],
				y: [Math.abs(data.export.YTD.value_yoy - data.import.YTD.value_yoy),
					Math.abs(data.export.YTD.value - data.import.YTD.value)]
			}
			let matmonth = {
				x: ['去年', '今年'],
				y: [Math.abs(data.export.MAT.value_yoy - data.import.MAT.value_yoy),
					Math.abs(data.export.MAT.value - data.import.MAT.value)]
			}
			this.currentmonth = currentmonth
			this.last3month = last3month
			this.ytdmonth = ytdmonth
			this.matmonth = matmonth

			/**
			 * 进口 VS 出口
			 */
			let currentmonth1 = this.importexport(data.import.current.value_yoy, data.export.current.value_yoy,
																						data.import.current.value, data.export.current.value)
			let last3month1 = this.importexport(data.import.lastThreeMonth.value_yoy, data.export.lastThreeMonth.value_yoy,
																					data.import.lastThreeMonth.value, data.export.lastThreeMonth.value)
			let ytdmonth1 = this.importexport(data.import.YTD.value_yoy, data.export.YTD.value_yoy,
																				data.import.YTD.value, data.export.YTD.value)
			let matmonth1 = this.importexport(data.import.MAT.value_yoy, data.export.MAT.value_yoy,
																				data.import.MAT.value, data.export.MAT.value)
			this.currentmonth1 = currentmonth1
			this.last3month1 = last3month1
			this.ytdmonth1 = ytdmonth1
			this.matmonth1 = matmonth1
			
			this.initBarDetail('dashboardbarid01', this.maincolor, this.matmonth)
			this.initBarStack('dashboardbarid02', '#009473', '#dd4124', this.matmonth1)
			this.initBarDetail('dashboardbarid1', '#009473', bar1data)
			this.initBarDetail('dashboardbarid2', '#dd4124', bar2data)
		},

		/**
		 * 净进/出口图
		 */
		initMiniBar: function(type){
			if(type == 0){
				this.initBarDetail('dashboardbarid01', this.maincolor, this.matmonth)
				this.initBarStack('dashboardbarid02', '#009473', '#dd4124', this.matmonth1)
			}
			if(type == 1){
				this.initBarDetail('dashboardbarid01', this.maincolor, this.ytdmonth)
				this.initBarStack('dashboardbarid02', '#009473', '#dd4124', this.ytdmonth1)
			}
			if(type == 2){
				this.initBarDetail('dashboardbarid01', this.maincolor, this.last3month)
				this.initBarStack('dashboardbarid02', '#009473', '#dd4124', this.last3month1)
			}
			if(type == 3){
				this.initBarDetail('dashboardbarid01', this.maincolor, this.currentmonth)
				this.initBarStack('dashboardbarid02', '#009473', '#dd4124', this.currentmonth1)
			}
		},

    /**
     * 24个月统计图
     */
    initBarDetail: function(id, barcolor, data){
			let that = this
      let myBarChart = this.echarts.init(document.getElementById(id))
      myBarChart.clear()
      myBarChart.setOption({
        grid: {
          left: 50,
          top: 30,
          bottom: 30,
          right: 10,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
						let _n = params[0].value * 1
						return params[0].name + ': ' + that.millonFormat(_n.toFixed(0))
					},
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ffffff'
            }
          },
          data: data.x
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ffffff'
            }
          },
        },
        series: [{
          data: data.y,
          type: 'bar',
          barCategoryGap: '40%'
        }],
        color: [barcolor]
      })
      $(window).resize(function () {
        myBarChart.resize();
      })
    },

    /**
     * 进口 VS 出口
     */
    initBarStack: function(id, barcolor1, barcolor2, data){
			let that = this
      let myBarChart = that.echarts.init(document.getElementById(id))
      myBarChart.clear()
      myBarChart.setOption({
        grid: {
          left: 50,
          top: 30,
          bottom: 30,
          right: 10,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params){
            let _t = [params[1].marker + that.$t('charttxt.t2') + '：' +  params[1].data + '%',
                      params[0].marker + that.$t('charttxt.t1') + '：' +  params[0].data + '%']
            return _t.join('<br>')
          }
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ffffff'
            }
          },
          data: ['去年', '今年']
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ffffff'
            }
          },
					axisLabel: {
						formatter: function (value) {
              return value + '%'
            }
					}
        },
        series: [{
          data: data.data1,
          type: 'bar',
          barCategoryGap: '40%',
          stack: 'total',
          label: {
            show: false,
						formatter: '{c}%',
          },
        }, {
          data: data.data2,
          type: 'bar',
          barCategoryGap: '40%',
          stack: 'total',
          label: {
            show: false,
						formatter: '{c}%',
          },
        }],
        color: [barcolor1, barcolor2]
      })
      $(window).resize(function () {
        myBarChart.resize();
      })
    },

		/**
		 * 进出口比值
		 */
		importexport: function(i, e, i1, e1){
			let v = {
				data1: [0, 0],
				data2: [0, 0]
			}
			let total = i * 1 + e * 1
			let total1 = i1 * 1 + e1 * 1
			let v1 = (i * 100 / total).toFixed(1)
			let v2 = (e * 100 / total).toFixed(1)
			let v3 = (i1 * 100 / total1).toFixed(1)
			let v4 = (e1 * 100 / total1).toFixed(1)
			v = {
				data1: [v1, v3],
				data2: [v2, v4]				
			}
			return v
		},

	},

}
</script>